import { BenefitDocumentDto } from '@zorro/clients';

/**
 * Names a rename action must not collide with: everything on the tab, ICHRA included.
 */
export const getExistingFileNames = (
  benefitDocuments: BenefitDocumentDto[] | undefined,
  ichraLetterDocument: { fileName: string } | null
): string[] => [
  ...(benefitDocuments?.map((document) => document.fileName) ?? []),
  ...(ichraLetterDocument ? [ichraLetterDocument.fileName] : []),
];

export const getGroupedBenefitDocuments = (
  benefitDocuments: BenefitDocumentDto[] | undefined
) => {
  const adminDocuments: BenefitDocumentDto[] = [];
  const planDocuments: BenefitDocumentDto[] = [];

  benefitDocuments?.forEach((document) => {
    if (document.isSharedWithEmployee) {
      planDocuments.push(document);
    } else {
      adminDocuments.push(document);
    }
  });

  return { adminDocuments, planDocuments };
};
